/*** IMPORTS FROM imports-loader ***/
var define = false;

"use strict";

var ko = require("knockout");

var pli = require("../core");

if (require("targetenv").isBrowser) {
    require("./pliTextBoxBinding");
}

module.exports = pli.observable = ko.observablePliTextBox = require("./PliTextBoxObservable");




//////////////////
// WEBPACK FOOTER
// ./~/pli/forms-knockoutcontrols/index.js
// module id = 15
// module chunks = 49